import asyncComponent from 'src/components/asyncComponent/asyncComponent';

export default asyncComponent(() => import('./async/Chart'));
